<template>
    <div :style="[elementStyles, basicContentStyles]">
        <canvas ref="canvas" :width="width" :height="height" class="hidden"></canvas>
        <div :dir="direction" :class="[data.text_animation_type === 'newsticker' ? 'newsticker' : '', 'text']"
             :style="[verticalAlign, { textShadow: textShadow, textOverflow: 'clip', whiteSpace: 'nowrap', overflow: 'hidden', maxHeight: height, maxWidth: width, width: '100%', height: '100%' }]"
             ref="rssfeed"
             v-html="rssFeedContent"/>
    </div>
</template>

<script>
    export default {
        props: {
            /** @type {PublishElementDataCommon | PublishElementDataRssFeed} */
            data: Object,
            frame: Object,
            width: Number,
            height: Number,
            basicContentStyles: Object
        },
        data: function () {
            return {
                fontfamily: 'Arial',
                fontsize: '30',
                valign: 'top',
                align: 'left',
                text: '',
                t_rssfeed: Lang.langGet('RSS Feed')
            }
        },
        computed: {
            elementStyles: function() {
                let backOpacity = 1;
                if(!isNaN(this.data.back_transparency) && this.data.back_transparency !== null) {
                    backOpacity -= this.data.back_transparency/100;
                }
                // 0.999: such that border when selected is visualized correctly.
                backOpacity = Math.min(backOpacity, 0.999);
                let backgroundColor = 'rgba(' + this.hexToRgb(this.data.secondary_color.replace('#','')) + ',' + backOpacity + ')';
                let opacity = 1;
                if(!isNaN(this.data.transparency)) {
                    opacity -= this.data.transparency/100;
                }

                return {
                    backgroundColor: backgroundColor,
                    opacity: opacity,
                    color: this.data.primary_color,
                    fontSize: this.fontsize + 'pt',
                    fontFamily: '"' + this.fontfamily + '"',
                    textAlign: this.data.text_align,
                    verticalAlign: this.valign,
                    textDecoration: this.textDecoration,
                    fontStyle: this.fontStyle,
                    fontWeight: this.fontWeight,
                    lineHeight: this.lineheight,
                }
            },
            verticalAlign: function() {
                let top = '0%';
                let left = '0%';

                if(this.valign === 'middle') {
                    top = '50%';
                } else if(this.valign === 'bottom') {
                    top = '100%';
                }

                if(this.align === 'center') {
                    left = '50%';
                } else if(this.align === 'right') {
                    left = '100%';
                }

                return {
                    position: 'relative',
                    top: top,
                    left: left,
                    transform: 'translate(-' + left + ',-' + top + ')',
                }
            },
            textDecoration: function () {
                if (this.data.text_decoration === 'underline') {
                    return 'underline';
                }

                return 'none';
            },
            fontStyle: function () {
                if (this.data.text_style === 'italic') {
                    return 'italic';
                }

                return 'normal';
            },
            fontWeight: function () {
                if (this.data.text_weight === 'bold') {
                    return 'bold';
                }

                return 'normal';
            },
            direction: function() {
                if(this.data.text_direction === 'ltr') {
                    return 'ltr';
                } else {
                    return 'rtl';
                }
            },
            textShadow: function () {
                if(this.data.drop_shadow != null && this.data.drop_shadow !== '') {
                    // Note: I don't know, why the factor 1.8 produces a better result...
                    var d = parseInt(this.data.drop_shadow) * this.frame.ratio * 1.8;
                    var b = 4 * this.frame.ratio * 1.8;
                    return d + 'px ' + d + 'px ' + b + 'px rgb(0, 0, 0)';
                } else {
                    return '';
                }
            },
            rssFeedContent() {
                return `${this.t_rssfeed}:${this.data.rssfeed_url}` //<br/>
            }
        },
        watch: {
            data: {
                handler() {
                    this.calcFont();
                },
                deep: true,
            },
            width: function () {
                this.calcFont();
            }
        },
        methods: {
            calcFont: function () {
                if (typeof this.data.text_size !== 'undefined' && this.data.text_size !== null && this.data.text_size !== '') {
                    this.fontsize = (parseInt(this.data.text_size) * this.frame.ratio);
                } else {
                    this.fontsize = 0;
                }
                if (typeof this.data.text_family !== 'undefined' && this.data.text_family !== null && this.data.text_family.length > 0) {
                    this.fontfamily = this.data.text_family;
                }
                this.valign = this.data.text_valign;
                this.align = this.data.text_align;

                if(this.$refs.canvas) {
                    const ctx = this.$refs.canvas.getContext('2d');
                    ctx.font = 4/3 * this.fontsize + 'px ' + this.fontfamily; //4/3 ithe factor from pt to px.
                    let width = ctx.measureText(this.text).width;
                    let height = this.fontsize;

                    let fit = '';
                    let autoscale = parseFloat(this.data.text_autoscale);
                    if (autoscale > 1) {
                        fit = 'vertical';
                    } else if (autoscale < -1) {
                        fit = 'horizontal';
                    } else if (autoscale === 1) {
                        if ((width > this.width) && (width / height > this.width / this.height)) {
                            fit = 'width';
                        } else if (height > this.height) {
                            fit = 'height';
                        }
                    } else if (autoscale === -1) {
                        if (width / height > this.width / this.height) {
                            fit = 'width';
                        } else {
                            fit = 'height';
                        }
                    }

                    if (fit === 'vertical') {
                        this.fontsize = this.fontsize / this.data.text_autoscale * this.height;
                    } else if (fit === 'horizontal') {
                        this.fontsize = this.fontsize / Math.abs(this.data.text_autoscale) * this.width;
                    } else if (fit === 'height') {
                        this.fontsize = this.height;
                        this.valign = 'middle';
                    } else if (fit === 'width') {
                        this.fontsize = this.width * this.fontsize / width;
                        this.align = 'center';
                    }
                    this.lineheight = 1;
                }
            },
            hexToRgb(hex) {
                let bigint = parseInt(hex, 16);
                let r = (bigint >> 16) & 255;
                let g = (bigint >> 8) & 255;
                let b = bigint & 255;

                return r + "," + g + "," + b;
            }
        },
        mounted() {
            this.calcFont();
        }
    }
</script>
